import TuneIcon from '@mui/icons-material/Tune';
import { Box, Typography } from '@mui/material';

export const MobileFilterSortButton = ({
  handleOpenCloseDialog,
  isBankBonusesFilterExperiment,
}: {
  handleOpenCloseDialog: () => void;
  isBankBonusesFilterExperiment?: boolean;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        borderRadius: '8px',
        ...(isBankBonusesFilterExperiment
          ? { border: '1px solid', borderColor: 'neutral.lighter' }
          : { backgroundColor: 'neutral.lightest', height: 56, border: 'none', p: 2 }),
      }}
    >
      <Box
        component="button"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 3,
          py: 2,
          borderRadius: '8px',
          backgroundColor: 'white',
          height: 40,
          width: '100%',
          cursor: 'pointer',
          border: 0,
        }}
        onClick={handleOpenCloseDialog}
      >
        <Typography sx={{ fontSize: 16, color: 'text.secondary', fontWeight: 500 }}>
          Filters & Sort
        </Typography>
        <TuneIcon sx={{ color: 'text.secondary', fontSize: 24 }} />
      </Box>
    </Box>
  );
};
